import React, { useState, useEffect } from 'react';

import Places from '../places/places';
import Shifts from '../shifts/shifts';

import './index.css';

const Main = () => <Shifts />;
export default Main;
